import requestProducts from "@utils/requestProducts"
import requestStaticProps from "@utils/requestStaticProps"
import ProSeries from "@views/ProSeries"
import {
  allPathsProSeriesQuery,
  proSeriesCategoryQuery,
} from "@views/ProSeries/graphql"
import _ from "lodash"
import { GetStaticPaths, GetStaticProps } from "next"

export default ProSeries

export const getStaticPaths: GetStaticPaths = async () => {
  const { data, error } =
    (await requestStaticProps(allPathsProSeriesQuery)) || {}

  if (error) {
    console.error(error)
  }

  const paths = data.collectionsConfiguration.proSeries.map(
    ({ proSeriesCategory }) => ({
      params: { category: proSeriesCategory.slug },
    })
  )

  return { paths, fallback: false }
}

export const getStaticProps: GetStaticProps = async ({
  params,
  preview = false,
}) => {
  const { data: pathsData, error: pathsError } =
    (await requestStaticProps(allPathsProSeriesQuery)) || {}

  if (pathsError) {
    console.error(pathsError)
  }

  const mappedCategories = pathsData.collectionsConfiguration.proSeries.map(
    ({ proSeriesCategory: { id, name, slug, bannerBody, bannerImage } }) => ({
      id,
      name,
      slug,
      bannerBody,
      bannerImage,
    })
  )

  const thisCategory = params?.category
    ? mappedCategories.find(({ slug }) => slug === params?.category)
    : []

  const { data, error, dataLoaded } =
    params?.category && thisCategory
      ? await requestProducts(proSeriesCategoryQuery, {
          categoryId: thisCategory.id,
        })
      : {
          data: {},
          error: undefined,
          dataLoaded: false,
        }

  if (error) {
    console.error(error)
  }

  const mergedData = {
    ...data,
    ..._.pick(pathsData, ["collectionsConfiguration"]),
  }

  return {
    props: {
      title: `Pro Series ${thisCategory.name}`,
      category: thisCategory,
      data: mergedData,
      dataLoaded: !!dataLoaded,
    },
  }
}
